import { Component, OnInit, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { Router } from '@angular/router';
import { MetaService } from '@ngx-meta/core';
import { URL } from '../../environments/environment';
import { RACKEO_SITE } from '../shared/rackeo-site';
import { CanonicalService } from '../shared/services/canonical.service';
@Component({
    selector: 'app-paga-deuda',
    templateUrl: 'paga-deuda.component.html',
    styleUrls: ['./paga-deuda.component.scss']
})

export class PagaDeudaComponent implements OnInit {
    public dataNoResult = '';
    public dataResult = false;
    public isLoading = false;
    public isNoResult = false;
    public isComplete = false;
    public URL = URL;
    constructor(
        @Inject(PLATFORM_ID) private readonly platformId: object,
        private readonly _meta: MetaService,
        private readonly _router: Router,
        private readonly canonical: CanonicalService
    ) { }

    ngOnInit() {
        if (!RACKEO_SITE.isChile) {
            if (isPlatformBrowser(this.platformId)) {
                this._router.navigate(['/'], { replaceUrl: true });
            }
            return;
        }
        this._setMetaCL();
    }

    public getLoadingStatus(ev: boolean): void {
        this.isLoading = ev;
    }

    public getNoResultVisibility(ev: any): void {
        this.isNoResult = ev.show;
        if (ev.status === 'No found' || ev.status === 'error') {
            this.dataNoResult = 'no-results';
        } else if (ev.status === 'badInput') {
            this.dataNoResult = 'bad-query';
        }
    }

    public getCompleteStatus(ev: any): void {
        this.isComplete = ev.show;
        this.dataResult = ev;
    }

    private _setMetaCL(): void {
        this._meta.setTitle('Pago de cuentas Rackeo: Pago directo Rackeo');
        this._meta.setTag('description', 'Paga tu deuda al instante con Pago Directo Rackeo. Pago de cuentas de Hosting Chile.');
        this._meta.setTag('keywords', 'Hosting, Rackeo, hosting Chile, pago de cuentas, pago directo Rackeo, VPS, certificado SSL, dominios, consulta de deuda, pago de deuda');
        this._meta.setTag('og:type', 'website');
        this._meta.setTag('og:image:type', 'image/png');
        this._meta.setTag('og:image', RACKEO_SITE.paymentOgImageUrl);
        this._meta.setTag('og:image:width', '1200');
        this._meta.setTag('og:image:height', '1200');
        this._meta.setTag('og:image:alt', 'Pago de cuentas Rackeo');
        this._meta.setTag('og:locale', RACKEO_SITE.ogLocale);
        this.canonical.set('/paga-deuda');
    }
}
